import { CONFIG } from "~/config";
import { IMapState } from "./interfaces";

// tohle se bude na par mistech hodit mit precteno
const searchParams = new URLSearchParams(window.location.search.slice(1, window.location.search.length));

// mame souradnice z URL? musi byt obe a obe validni, jinak ignorujeme
let coorX = NaN;

if (searchParams.has("x")) {
	const getX = parseFloat(searchParams.get("x"));

	if (!isNaN(getX) && getX >= -180 && getX <= 180) {
		coorX = getX;
	}
}

let coorY = NaN;

if (searchParams.has("y")) {
	const getY = parseFloat(searchParams.get("y"));

	if (!isNaN(getY) && getY >= -90 && getY <= 90) {
		coorY = getY;
	}
}

const validCoords = !isNaN(coorX) && !isNaN(coorY);

let coorZ = NaN;

if (searchParams.has("z")) {
	const getZ = parseInt(searchParams.get("z"));

	if (!isNaN(getZ) && getZ >= 1 && getZ <= 20) {
		coorZ = getZ;
	}
}

let yaw = 0;

if (searchParams.has("yaw")) {
	yaw = parseInt(searchParams.get("yaw"));
}

let pitch = 0;

if (searchParams.has("pitch")) {
	pitch = parseInt(searchParams.get("pitch"));
}

let height = 0;

if (searchParams.has("height")) {
	height = parseInt(searchParams.get("height"));
}

/** pole všech možných overlayů mapy */
export enum MAP_OVERLAYS {
	/** katastrální mapa */
	CADASTRAL = 1,
	/** fotomapa */
	PHOTO = 2,
	/** sklon svahu */
	HILLSHADE = 3,
	/** webkamery */
	WEBCAM = 4,
	/** turistické značky */
	TURIST = 5,
	/** dopravní situace */
	TRAFFIC = 6,
	/** běžky */
	SKI = 7,
	/** panorama */
	PANORAMA = 8,
}

let mapset = CONFIG.mapsets.find(ms => ms.seo === CONFIG.initialMapset) ? CONFIG.initialMapset : "zakladni";
let m3d = 0;

if (searchParams.has("m3d") && parseInt(searchParams.get("m3d")) === 1) {
	m3d = 1;

	// pokud prichazim na zakladni, ale ve 3D, tak jde o starou URL a videt bych mel spravne leteckou
	if (mapset === "zakladni") {
		mapset = "letecka";
	}
}

let initialOverlays = [...CONFIG.initialOverlays || (CONFIG.initialMapset === "zimni" ? [MAP_OVERLAYS.SKI] : [])];

// hotfix chyby, kdy k nezimni mape zapiname bezkarske trasy, protoze to tak ma uzivatel v datech
if (mapset !== "zimni" && initialOverlays.indexOf(MAP_OVERLAYS.SKI) > -1) {
	initialOverlays = [];
}

function getPadding() {
	const padding: IMapState["padding"] = {
		left: 0,
		right: 0,
		top: 70,
		bottom: 58,
	};

	// kod z provideru map
	if (CONFIG.inFrame) {
		const urlParams = new URL(document.location.toString()).searchParams;

		if (urlParams.has("ol") && parseInt(urlParams.get("ol"))) {
			padding.left = 40;
			padding.right = 40;
		} else {
			padding.left = 24;
			padding.right = 24;
			padding.top = 20;
			padding.bottom = 42;
		}
	} else {
		padding.left = 12;
		padding.right = 12;
	}

	return padding;
}

export const DEFAULT_MAP_STATE: IMapState = {
	longitude: validCoords ? coorX : CONFIG.initialMap.lon,
	latitude: validCoords ? coorY : CONFIG.initialMap.lat,
	zoom: isNaN(coorZ) ? CONFIG.initialMap.zoom : coorZ,
	yaw,
	pitch,
	height,
	animate: false,
	animating: false,
	ignore: false,
	mapset,
	provider: m3d === 1
		? "m3d"
		: "map",
	providerChanging: false,
	overlays: [...initialOverlays],
	currentOverlays: {
		[CONFIG.initialMapset]: [...initialOverlays],
	},
	desaturate: false,
	ophotoTimeline: "",
	ophotoDate: "",
	copyrights: [],
	padding: getPadding(),
	egg: "none",
	fit: [],
};
